import { Reaction } from '../../../../../../models/CommentHistory/Comment';
import { Reaction as ApiReaction } from '../../Models/ApiComment';

export function toReaction(reaction: ApiReaction): Reaction {
  return {
    uuid: reaction.uuid,
    createdAt: reaction.created_at ? new Date(reaction.created_at) : undefined,
    username: reaction.username,
    type: reaction.type,
  };
}
